import GrowthIcon from "@/assets/icons/GrowTopArrow.svg";
import { CustomButton } from "@/components/ui/Buttons";
import { EventType } from "./EventTypes";
import { Dispatch, SetStateAction } from "react";

const EventCard = ({
  event,
  setIsSelectModalOpen,
}: {
  event: EventType;
  setIsSelectModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  // handle "in X days" vs "X days ago"
  const renderDaysText = () => {
    if (event.days_until > 0) {
      return (
        <p className="text-[#006DBA] bg-[#EDF7FF] py-1 px-4 rounded-[10px] text-[15px]">
          in <span className="font-semibold">{event.days_until} days</span>
        </p>
      );
    }
    if (event.days_until === 0) {
      return (
        <p className="text-[#E67E22] bg-[#FFF3E6] py-1 px-4 rounded-[10px] text-[15px] font-medium">
          Today 🎉
        </p>
      );
    }
    return (
      <p className="text-[#9B1C1C] bg-[#FEE2E2] py-1 px-4 rounded-[10px] text-[15px]">
        <span className="font-semibold">{Math.abs(event.days_until)} days</span>{" "}
        ago
      </p>
    );
  };

  return (
    <div className="mb-6 border border-[#E4E7EC] px-6 py-4 rounded-lg">
      {/* Top Row */}
      <div className="flex flex-col md:flex-row justify-between md:items-start gap-3 mb-3">
        <div className="flex gap-x-3">
          <p className="text-[15px] text-[#777777] bg-[#F3F3F3] px-[5px] py-[3.5px] rounded-lg">
            {event.date}
          </p>
          {renderDaysText()}
        </div>
        <CustomButton
          // onClick={() => setIsSelectModalOpen(true)}
          variant="outline"
          border="1px solid #E4E7EC"
          borderRadius="12px"
          padding="10px"
          color="black"
          fontSize="16px"
          fontWeight="500"
          className="w-full md:w-[216px] leading-6 tracking-[1.5%]"
        >
          View Videos
        </CustomButton>
      </div>

      {/* Bottom Row */}
      <div className="flex flex-col md:flex-row justify-between md:items-start gap-3">
        <div>
          <h3 className="text-xl font-medium">{event.event}</h3>
          <p className="text-sm text-gray-500 mt-1">{event.description}</p>
          <div className="flex items-center gap-x-2 mt-2">
            <p className="text-[#777777] text-[15px]">Campaign starts</p>
            <p className="text-[#0B8000] text-[15px] bg-[#E2FFE3] px-[7.5px] py-1 rounded-[10px]">
              {event.campaign_hint}
            </p>
          </div>
        </div>
        {/* <CustomButton
          variant="outline"
          border="1px solid #E4E7EC"
          borderRadius="12px"
          padding="12px 25px"
          color="#344054"
          fontSize="14px"
          fontWeight="500"
          className="flex gap-x-2 items-center"
        >
          <GrowthIcon />
          View Previous Year Outcomes
        </CustomButton> */}
      </div>
    </div>
  );
};

export const NoEvents = () => (
  <div className="flex flex-col items-center justify-center py-12 text-center">
    <div className="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4 text-3xl">
      📭
    </div>
    <h4 className="text-lg font-medium text-gray-700 mb-2">No events found</h4>
    <p className="text-gray-500 max-w-xs">
      Looks like there aren’t any events matching this filter. Try selecting a
      different range or check back later.
    </p>
  </div>
);

const SkeletonBox = ({ className }: { className: string }) => (
  <div className={`bg-gray-200 animate-pulse ${className}`} />
);

export const EventCardSkeleton = () => (
  <div className="mb-6 border border-[#E4E7EC] px-6 py-4 rounded-lg">
    {/* Top row */}
    <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4">
      <div className="flex gap-x-3">
        <SkeletonBox className="h-[28px] w-[80px] rounded-lg" />
        <SkeletonBox className="h-[28px] w-[120px] rounded-lg" />
      </div>
      <SkeletonBox className="h-[40px] w-[150px] rounded-lg" />
    </div>

    {/* Bottom row */}
    <div className="flex flex-col md:flex-row justify-between gap-3">
      <div className="flex-1">
        <SkeletonBox className="h-6 w-[200px] mb-2 rounded" />
        <div className="flex items-center gap-x-2">
          <SkeletonBox className="h-4 w-[120px] rounded" />
          <SkeletonBox className="h-6 w-[90px] rounded-lg" />
        </div>
      </div>
      <SkeletonBox className="h-[40px] w-[220px] rounded-lg" />
    </div>
  </div>
);

export default EventCard;
